import { mapActions } from "vuex";

export const storeMixin = {
  data() {
    return {
      message: ""
    };
  },
  methods: {
    ...mapActions(["getAccountAction"]),
    async loadAccount(id) {
      this.message = "getting account, please wait";
      console.log("this.$store.state", this.$store.state);
      try {
        await this.getAccountAction({
          id: id,
          token: this.$store.state.token
        });
        if (this.$store.state.account == null) {
          this.logout();
          console.log("im logged out");
          this.$router.go();
        }
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
      console.log("clear message");
      this.message = "";
    }
  }
};
